import styled, { css } from "styled-components";
import { Anchor, Flex } from "discover.medical.react-component-library";

export const primaryContentStyles = () => css`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.lg};
  &.explore-resources {
    margin-bottom: 1rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-right: ${({ theme }) => theme.space.xl};
    float: left;
    &.explore-resources {
      margin-bottom: 0.5rem;
    }
  }
`;

export const secondaryContentStyles = () => css`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.lg};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-left: auto;
  }
`;

export const ContentWrapper = styled(Flex)`
  width: 100%;
  padding: 0 0.625rem;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
    padding: 0 1.25rem;
    margin: 0 auto;
  }
`;

/*
  These styled components are shared between Bookmarks, and ExploreContent
*/
export const HomeListItem = styled.li`
  margin-bottom: ${({ theme }) => theme.space.sm};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: ${({ theme }) => theme.space.md};
  }
`;

export const HomeLink = styled(Anchor)`
  font-size: ${({ theme }) => theme.font.size.sm};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.md};
  }
`;
